import { SVGProps } from 'react';

export function CloseIcon(props: SVGProps<SVGSVGElement>) {
  const { fill, width, height } = props;

  return (
    <svg width={width ?? '10'} height={height ?? width ?? '9'} viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.2136 0.262591C1.56508 -0.0875303 2.13492 -0.0875303 2.4864 0.262591L5 2.76658L7.51361 0.262591C7.86506 -0.0875303 8.43494 -0.0875303 8.78639 0.262591C9.13784 0.612721 9.13784 1.18038 8.78639 1.53051L6.27278 4.03448L8.78639 6.53846C9.13784 6.88857 9.13784 7.45626 8.78639 7.80637C8.43494 8.15647 7.86506 8.15647 7.51361 7.80637L5 5.30239L2.4864 7.80637C2.13492 8.15647 1.56508 8.15647 1.2136 7.80637C0.862133 7.45626 0.862133 6.88857 1.2136 6.53846L3.72722 4.03448L1.2136 1.53051C0.862133 1.18038 0.862133 0.612721 1.2136 0.262591Z"
        fill={fill ?? 'white'}
      />
    </svg>
  );
}
